import React, { Component } from 'react';
import { Divider, Switch, Intent, Tag, HTMLTable } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Regions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      regions: [
        { id: 1, name: 'Jangan & Tiger Mountain', status: true, minLevel: 1, pvpAllowed: true },
        { id: 2, name: 'Donwhang & Donwhang Cave', status: true, minLevel: 20, pvpAllowed: true },
        { id: 3, name: 'Hotan & Taklamakan Desert', status: true, minLevel: 40, pvpAllowed: true },
        { id: 4, name: 'Samarkand & Central Asia', status: true, minLevel: 20, pvpAllowed: true },
        { id: 5, name: 'Constantinople & Asia Minor', status: true, minLevel: 1, pvpAllowed: true },
        { id: 6, name: 'Alexandria North & South', status: true, minLevel: 100, pvpAllowed: true },
        { id: 7, name: 'Roc Mountain Peak', status: true, minLevel: 90, pvpAllowed: true },
        { id: 8, name: 'Holy Water Temple & Job Cave', status: true, minLevel: 105, pvpAllowed: true },
      ],
    };
  }

  toggleRegion = (index) => {
    const updated = [...this.state.regions];
    updated[index].status = !updated[index].status;
    this.setState({ regions: updated });
  };

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Map Region Locks & Zone Permissions
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Enable or disable map regions, level caps per zone, and PVP zone restrictions.
        </p>

        <Divider className="mb-4" />

        <HTMLTable bordered condensed striped style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>Region Name</th>
              <th style={{ color: '#182026' }}>Min Level Required</th>
              <th style={{ color: '#182026' }}>PVP Status</th>
              <th style={{ color: '#182026' }}>Region Status</th>
              <th style={{ color: '#182026' }}>Action Toggle</th>
            </tr>
          </thead>
          <tbody>
            {this.state.regions.map((reg, idx) => (
              <tr key={idx}>
                <td className="font-weight-bold" style={{ color: '#182026' }}>{reg.name}</td>
                <td><Tag intent={Intent.WARNING} minimal>Lv. {reg.minLevel}+</Tag></td>
                <td><Tag intent={Intent.DANGER} round>PVP ENABLED</Tag></td>
                <td><Tag intent={reg.status ? Intent.SUCCESS : Intent.NONE} round>{reg.status ? 'UNLOCKED' : 'LOCKED'}</Tag></td>
                <td>
                  <Switch checked={reg.status} onChange={() => this.toggleRegion(idx)} className="m-0" />
                </td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </SideMenuWrapper>
    );
  }
}
